import { APP_CONSTANTS } from 'src/consumer/constants'
import logo_brand from 'src/assets/logo_brand.png'

import React, { useState, useEffect, useContext } from 'react'
import NavDropdown, {
  BackButton,
  CenterImage,
  DropdownContainer,
  LanguageSelectStylesForm,
  NavbarParent,
  SelectContainer,
} from './FormNavbarStyles'
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext'
import Select from 'react-select'
import { useNavigate } from 'react-router-dom'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { LocalizationContext } from 'src/consumer/context/LocalizationContext'

export default function FormNavbar(props) {
  const { goBackFunction, backVisible, languageSelectVisible, logoutDropDownVisible } = props
  const { unSecureSetupLoading, unSecureSetupData, unSecureSetupError } =
    useContext(UnsecureSetupContext)
  const navigate = useNavigate()
  const [lang, setLang] = useState([])
  const { localizedData } = useContext(LocalizationContext)
  const localizedStrings = localizedData?.strings?.onboardingFlow

  useEffect(() => {
    setLang(unSecureSetupData?.appLanguages)
  }, [unSecureSetupData])

  let languages = []
  lang?.forEach((item) => {
    languages.push({ value: item?.id, label: item?.localLanguageName })
  })

  const getActiveLanguage = (languages) => {
    return languages?.find((language) => {
      if (language?.value === sessionStorage.getItem('languageCode')) {
        return language
      }
    })
  }

  return (
    <NavbarParent>
      {backVisible && (
        <BackButton onClick={() => goBackFunction()}>
          <ArrowBackIosIcon sx={{ fontSize: 16 }} /> {localizedStrings?.back || "Back"}
        </BackButton>
      )}

      <CenterImage
        src={APP_CONSTANTS.APP_LOGO_LINK} 
        alt='logoBrand'
        onError={(e) => {
          e.target.src = logo_brand
        }}
        onClick={() => {
          if (!localStorage.getItem('token')) {
            window.location.href = 'https://aumhum.com'
          } else {
            navigate('/', {})
          }
        }}
      />

      {languageSelectVisible && (
        <SelectContainer>
          <Select
            options={languages}
            isSearchable={false}
            components={{ IndicatorSeparator: () => null }}
            value={getActiveLanguage(languages)}
            styles={LanguageSelectStylesForm}
            onChange={(selected) => {
              sessionStorage.setItem('languageCode', selected.value)
              window.location.reload()
            }}
          />
        </SelectContainer>
      )}

      {logoutDropDownVisible && (
        <DropdownContainer>
          <NavDropdown />
        </DropdownContainer>
      )}
    </NavbarParent>
  )
}
